var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback"},[(_vm.loading)?_c('p',[_vm._v("Loading...")]):_vm._e(),(!_vm.gamePlaying)?_c('p',[_vm._v(_vm._s(_vm.feedback))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }